import { useEffect, useState } from "react";
import { Button, Modal } from "react-bootstrap";
import { DateInput, FormLabel, NumberInput } from "../../../components/forms";
import { BusinessSheetStatusSelect, GenericAdviserSelect, GenericUserSelect, ReportStatusSelect, ReportTypesSelect } from "../../../components/forms/selects";
import { useFilterContext } from "../../../hooks/FilterContext";

const AdviceRegisterFiltersModal = () => {
    const {
        filter,
        setFilter,
        showFilterModal,
        setShowFilterModal,
        defaultFilters
    } = useFilterContext();

    const onHide = () => setShowFilterModal(false);

    const [tempFilters, setTempFilters] = useState(filter);

    const updateFilter = (prop, value) => setTempFilters(old => ({
        ...old,
        [prop]: value
    }));

    const onClear = () => setTempFilters(defaultFilters);

    const reset = () => setTempFilters(filter);
    const onCancel = () => {
        reset();
        onHide();
    }

    const onApply = () => setFilter(tempFilters);
    const onConfirm = () => {
        onApply();
        onHide();
    }

    const {
        sentToClientStartDate,
        sentToClientEndDate,
        passedComplianceStartDate,
        passedComplianceEndDate,
        reportTypeIds,
        authorIds,
        adviserIds,
        complianceOfficerIds,
        minRejectCount,
        maxRejectCount,
        reportStatusIds,
        businessSheetStatuses
    } = tempFilters;

    useEffect(() => {
        setTempFilters(filter);
    }, [filter]);

    return <Modal
        show={showFilterModal}
        onHide={onCancel}
        size="xl"
        centered
    >
        <Modal.Header closeButton>
            Advice Register Filters
        </Modal.Header>
        <Modal.Body>
            <div className="row gy-2">
                <div className="col-12 col-lg-6 d-flex flex-row">
                    <span className="col mt-auto">
                        <DateInput
                            label={"Sent From"}
                            value={sentToClientStartDate}
                            maxDate={new Date()}
                            onBlur={(date) => updateFilter('sentToClientStartDate', date)}
                            disableAnimations
                            isClearable
                        />
                    </span>
                    <FormLabel className="col-auto mt-auto px-2">
                        To
                    </FormLabel>
                    <span className="col mt-auto">
                        <DateInput
                            value={sentToClientEndDate}
                            maxDate={new Date()}
                            onBlur={(date) => updateFilter('sentToClientEndDate', date)}
                            disableAnimations
                            isClearable
                        />
                    </span>
                </div>
                <div className="col-12 col-lg-6 d-flex flex-row">
                    <span className="col mt-auto">
                        <DateInput
                            label={"Compliant From"}
                            value={passedComplianceStartDate}
                            maxDate={new Date()}
                            onBlur={(date) => updateFilter('passedComplianceStartDate', date)}
                            disableAnimations
                            isClearable
                        />
                    </span>
                    <FormLabel className="col-auto mt-auto px-2">
                        To
                    </FormLabel>
                    <span className="col mt-auto">
                        <DateInput
                            value={passedComplianceEndDate}
                            maxDate={new Date()}
                            onBlur={(date) => updateFilter('passedComplianceEndDate', date)}
                            disableAnimations
                            isClearable
                        />
                    </span>
                </div>
                <div className="col-6 col-lg-4 order-lg-1">
                    <ReportTypesSelect
                        label="Type"
                        defaultValue={reportTypeIds}
                        onChange={(selections) => updateFilter('reportTypeIds', selections.map(s => s.value))}
                        isMulti
                        isClearable
                        disableAnimations
                    />
                </div>
                <div className="col-6 col-lg-4">
                    <GenericUserSelect
                        label="Author"
                        defaultValue={authorIds}
                        onChange={(selections) => updateFilter('authorIds', selections.map(s => s.value))}
                        isMulti
                        isClearable
                        disableAnimations
                    />
                </div>
                <div className="col-6 col-lg-4">
                    <GenericAdviserSelect
                        label="Adviser"
                        defaultValue={adviserIds}
                        onChange={(selections) => updateFilter('adviserIds', selections.map(s => s.value))}
                        isMulti
                        isClearable
                        disableAnimations
                    />
                </div>
                <div className="col-6 col-lg-4">
                    <GenericUserSelect
                        label="Compliance Officer"
                        defaultValue={complianceOfficerIds}
                        onChange={(selections) => updateFilter('complianceOfficerIds', selections.map(s => s.value))}
                        isMulti
                        isClearable
                        disableAnimations
                    />
                </div>
                <div className="col-6 col-lg-4 order-lg-1 d-flex flex-row">
                    <span className="col mt-auto">
                        <NumberInput
                            label={"Reject Count"}
                            value={minRejectCount ?? ""}
                            decimalScale={0}
                            onChange={(_, { floatValue }) => updateFilter('minRejectCount', floatValue)}
                            disableAnimations
                        />
                    </span>
                    <FormLabel className="col-auto mt-auto px-2">
                        To
                    </FormLabel>
                    <span className="col mt-auto">
                        <NumberInput
                            value={maxRejectCount ?? ""}
                            decimalScale={0}
                            onChange={(_, { floatValue }) => updateFilter('maxRejectCount', floatValue)}
                            disableAnimations
                        />
                    </span>
                </div>
                <div className="col-6 col-lg-4">
                    <ReportStatusSelect
                        label="Report Status"
                        defaultValue={reportStatusIds}
                        onChange={(selections) => updateFilter('reportStatusIds', selections.map(s => s.value))}
                        disableAnimations
                        isMulti
                        isClearable
                    />
                </div>
                <div className="col-6 col-lg-4">
                    <BusinessSheetStatusSelect
                        headOfficeOnly
                        label="Business Sheet Status"
                        defaultValue={businessSheetStatuses}
                        onChange={(selections) => updateFilter('businessSheetStatuses', selections.map(s => s.value))}
                        disableAnimations
                        isMulti
                        isClearable
                    />
                </div>
            </div>
        </Modal.Body>
        <Modal.Footer>
            <Button variant="warning" onClick={onClear}>
                Clear Filters
            </Button>
            <Button variant="success" onClick={onConfirm}>
                Apply Filters
            </Button>
            <Button variant="light" onClick={onCancel}>
                Cancel
            </Button>
        </Modal.Footer>
    </Modal>
}

export default AdviceRegisterFiltersModal;